import React from 'react';
import { AccountTab } from 'src/domains/players/webview/components/Account/accountParts/accountTab/AccountTab';
import { TabWrapper } from './Account.style';
import { AccountDrawerHeader } from 'src/domains/players/webview/components/Account/accountDrawerHeader/AccountDrawerHeader';
import { TabDataPropsType } from 'src/domains/players/webview/components/Account/accountDrawer/AccountTabsBuilder.state';
import { observer } from 'src/utils/mobx-react';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';

interface TabSubComponentPropsType {
    tabData: TabDataPropsType;
}

const TabHeader = observer('TabHeader', (props: TabSubComponentPropsType) => {
    const { header, parent, useStepNavigation } = props.tabData;
    const common = useCommon();
    const { session } = common;

    if (header !== undefined) {
        if (header.component !== undefined) {
            return React.createElement(header.component, null, [header.title]);
        }

        return (
            <AccountDrawerHeader
                title={header.title}
                icon={header.icon}
                hasClose={header.close ?? true}
                hasBack={header.back === true && parent !== undefined}
                isSmallerVersion={header.isSmallerVersion}
                parent={parent}
                isAuthorized={session.isAuthorized}
                key='tab-header'
                useStepNavigation={useStepNavigation}
            />
        );
    }

    return null;
});

const TabContent = observer('TabContent', (props: TabSubComponentPropsType) => {
    const { tabData } = props;
    const componentJsx = tabData.component();

    return <AccountTab>{componentJsx}</AccountTab>;
});

interface TabPropsType {
    tabName: RightHandSideViewType | null;
    showHeader: boolean;
    tabData: TabDataPropsType | null;
    tabDataForHeader: TabDataPropsType | null;
}

export const Tab = observer('Tab', (props: TabPropsType) => {
    const { tabName, showHeader, tabData, tabDataForHeader } = props;
    const common = useCommon();
    const starRouter = StarRouter.get(common);

    //TODO - Temporary solution needed to be able to migrate to the new acountDrawer.
    //When the new acountDrawer is active, it will be possible to remove this reference in favour of information from the new acountDrawer state
    const account = starRouter.accountView?.account;
    const isActive = tabName?.account === account;
    const dataAccountDrawerTab = isActive ? 'account-drawer-tab-visible' : 'account-drawer-tab-hidden';

    let tabHeader = null;
    if (tabDataForHeader !== null && showHeader) {
        tabHeader = (
            <TabHeader
                key='tab-header'
                tabData={tabDataForHeader}
            />
        );
    }

    const tabContent = tabData === null ? null : <TabContent tabData={tabData} />;

    return (
        <TabWrapper
            key={`tab-${tabName?.account ?? ''}`}
            data-test={dataAccountDrawerTab}
        >
            {tabHeader}
            {tabContent}
        </TabWrapper>
    );
});
